<template lang="html">
  <v-container fluid>
    <v-row class="mb-2" align="center">
      <v-col cols="12" sm="8">
        <h2 class="headline font-weight-bold primary--text mb-0">Riwayat Kompetensi</h2>
      </v-col>
    </v-row>

    <v-skeleton-loader v-if="loading" type="table" />

    <v-data-table
      v-else-if="tableItems.length"
      :headers="headers"
      :items="tableItems"
      :items-per-page="10"
      class="elevation-1"
    >
      <template v-slot:item.actions="{ item }">
        <v-btn color="primary" small @click="goToReview(item.id)">
          <v-icon left small>mdi-eye-outline</v-icon>
          Review
        </v-btn>
      </template>
    </v-data-table>

    <v-card v-else class="pa-8 text-center" outlined>
      <v-icon size="64" color="grey lighten-1" class="mb-3">mdi-clipboard-text-off-outline</v-icon>
      <div class="title grey--text text--darken-1 mb-2">
        Belum ada riwayat pengerjaan kompetensi
      </div>
      <div class="body-2 grey--text mb-6">
        Mulai kerjakan soal kompetensi untuk melihat riwayat di sini.
      </div>
      <v-btn color="primary" @click="goToSoal">
        <v-icon left>mdi-pencil-outline</v-icon>
        Kerjakan Soal
      </v-btn>
    </v-card>
  </v-container>
</template>

<script>
import store from '@/store'
import KuesionerService from '@/services/KuesionerService'

export default {
  name: 'KuesionerKompetensi',
  data() {
    return {
      loading: true,
      histories: [],
      headers: [
        { text: 'No', value: 'no', sortable: false, width: '72px' },
        { text: 'Jumlah Soal', value: 'jumlah_soal_label', sortable: false },
        { text: 'Tanggal Pengerjaan', value: 'created_at_label' },
        { text: 'Action', value: 'actions', sortable: false, width: '140px' }
      ]
    }
  },
  computed: {
    tableItems() {
      return this.histories.map((item, index) => ({
        ...item,
        no: index + 1,
        jumlah_soal_label: (item.details_count || 0) + ' Soal',
        created_at_label: this.formatDate(item.created_at)
      }))
    }
  },
  created() {
    this.fetchHistories()
  },
  methods: {
    fetchHistories() {
      this.loading = true
      KuesionerService.getHasilKompetensi()
        .then(res => {
          this.histories = (res.data && res.data.data) || []
        })
        .catch(err => {
          const message = (err.response && err.response.data && err.response.data.message)
            || err.message
            || 'Gagal memuat riwayat kompetensi'
          store.commit('snackbar/setSnack', { message, color: 'error' })
          this.histories = []
        })
        .finally(() => {
          this.loading = false
        })
    },
    goToSoal() {
      this.$router.push('/kuesioner-kompetensi/soal')
    },
    goToReview(id) {
      this.$router.push(`/kuesioner-kompetensi/review/${id}`)
    },
    formatDate(value) {
      if (!value) return '-'
      const date = new Date(value.replace(' ', 'T'))
      if (Number.isNaN(date.getTime())) return value
      return date.toLocaleString('id-ID', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    }
  }
}
</script>
